import { render, staticRenderFns } from "./enPrivacy.vue?vue&type=template&id=7b594cb9&scoped=true&"
import script from "./enPrivacy.vue?vue&type=script&lang=js&"
export * from "./enPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./enPrivacy.vue?vue&type=style&index=0&id=7b594cb9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b594cb9",
  null
  
)

export default component.exports